import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
import {
  StyledSpending,
  StyledSpendingHeader,
} from './StyledSpending';
import OverviewCounters from '../OverviewCounters/OverviewCounters';
import SubscriptionChart from '../SubscriptionChart/SubscriptionChart';
import SpendingBarChart from '../SpendingBarChart';
import {cardsHelpers} from '../../../../utils/helpers';
import routes from '../../../../routes/routes.json';

const Spending = ({
  barChartData = [],
  chartVariant = 'linechart',
  counterProps,
  lineChartData = [],
  lineChartDataServices = [],
  ...rest
}) => {
  const navigate = useNavigate();

  const onBarClick = (e, { subscription_id, card_id, owner } = {}) => {
    if (!subscription_id && !card_id) return;
    const url = subscription_id
      ? `${routes.subscriptionsList}/${subscription_id}`
      : cardsHelpers.getCardDetailsUrl({ cardId: card_id, ownerId: owner?.id });
    navigate(url);
  };

  return (
    <StyledSpending
      align='start'
      direction='vertical'
      size='large'
      {...rest}
    >
      <StyledSpendingHeader>
        <OverviewCounters {...counterProps} />
      </StyledSpendingHeader>
      {chartVariant === 'barchart' ? (
        <SpendingBarChart
          barWidth={10}
          data={barChartData}
          onBarClick={onBarClick}
        />
      ) : (
        <SubscriptionChart
          data={lineChartData}
          tooltipServices={lineChartDataServices}
        />
      )}
    </StyledSpending>
  );
}

const counterPropTypes = PropTypes.shape({
  isLoaded: PropTypes.bool,
  value: PropTypes.any
})

Spending.propTypes = {
  barChartData: PropTypes.array,
  chartVariant: PropTypes.oneOf(['barchart', 'linechart']),
  counterProps: PropTypes.shape({
    actualTimeRange: PropTypes.string,
    data: PropTypes.shape({
      actual: counterPropTypes,
      expected: counterPropTypes
    }),
    enableBudgetCounter: PropTypes.bool,
  }),
  lineChartData: PropTypes.array,
  lineChartDataServices: PropTypes.array,
}

export default Spending;
